// Ícone SVG inline da bandeira Credsystem (sem requisição HTTP)
import * as React from 'react';

export function CredsystemIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 48 32" role="img" aria-label="Credsystem" {...props}>
      <rect width="48" height="32" rx="4" fill="#0B1D3A" />
      <text
        x="24"
        y="15"
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="800"
        fontSize="6"
        fill="#fff"
      >
        cred
      </text>
      <text
        x="24"
        y="23"
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="800"
        fontSize="6"
        fill="#F59E0B"
      >
        system
      </text>
    </svg>
  );
}
